import type { ColumnWidth } from '@/shared/lib';

/**
 * `<colgroup>` of a `table.table--fixed` (styles/table-fixed.css): the width of each column (see
 * `columnWidth` in shared/lib), so the columns stay put when the rows change (sorting, filtering,
 * paging). Flexible columns (`null`) share the remaining width.
 */
export function ColGroup({ widths }: { widths: readonly ColumnWidth[] }) {
  return (
    <colgroup>
      {widths.map((width, index) => (
        // Columns have no identity of their own; their position is their key.
        <col key={index} style={width === null ? undefined : { width }} />
      ))}
    </colgroup>
  );
}
